/* Risalti — Completa il look (snippets/risalti-complete-look.liquid) */
(() => {
  if (customElements.get('risalti-complete-look')) return;

  // Stesso colore scritto in modi diversi: "Nero Fuxia" = "Nero-Fucsia", "Nero/Antracite" = "Nero-Antracite"
  const norm = (s) =>
    String(s || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/fuxia/g, 'fucsia')
      .replace(/[|]/g, ' ')
      .replace(/[\s/_-]+/g, ' ')
      .trim();
  // Colore base: "Uva Lurex | LE" e "Uva | LE" -> "uva", "Nero Balance" -> "nero"
  const base = (s) => norm(s).replace(/\b(le|lurex|balance|italia)\b/g, ' ').replace(/\s+/g, ' ').trim();

  const money = (cents) =>
    window.theme && typeof window.theme.formatMoney === 'function'
      ? window.theme.formatMoney(cents, window.theme.moneyFormat)
      : (cents / 100).toFixed(2).replace('.', ',') + ' €';

  let cartStale = false;
  let cartToggleGuard = false;

  // Dopo un'aggiunta singola il carrello non si apre: al primo click sull'icona
  // lo ricarichiamo, cosi non mostra il contenuto vecchio.
  const guardCartToggle = () => {
    if (cartToggleGuard) return;
    cartToggleGuard = true;
    document.addEventListener(
      'click',
      (e) => {
        if (!cartStale) return;
        const toggle = e.target.closest('[data-cart-drawer-toggle]');
        if (!toggle) return;
        e.preventDefault();
        e.stopPropagation();
        openCart();
      },
      true
    );
  };

  const openCart = () => {
    cartStale = false;
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  };

  class LookItem {
    constructor(root, el) {
      this.root = root;
      this.el = el;
      this.role = el.dataset.rclItem;
      this.d = JSON.parse(el.querySelector('[data-rcl-data]').textContent);
      this.ci = this.d.colorIndex;
      this.si = this.d.sizeIndex;
      this.sel = this.d.selected.slice();
      this.added = false;
      this.img = el.querySelector('[data-rcl-img]');
      this.price = el.querySelector('[data-rcl-price]');
      this.btn = el.querySelector('[data-rcl-add]');
      this.msg = el.querySelector('[data-rcl-msg]');
      this.colorLabel = el.querySelector('[data-rcl-value-label]');

      el.addEventListener('click', (e) => {
        const b = e.target.closest('[data-rcl-value]');
        if (!b || b.disabled) return;
        const i = Number(b.closest('[data-rcl-option]').dataset.rclOption);
        this.set(i, b.dataset.rclValue);
      });
      this.btn.addEventListener('click', () => this.root.add([this]));
    }

    values(i) {
      const seen = [];
      this.d.variants.forEach((v) => {
        if (!seen.includes(v.o[i])) seen.push(v.o[i]);
      });
      return seen;
    }

    variant() {
      return this.d.variants.find((v) => v.o.every((x, i) => x === this.sel[i]));
    }

    // Variante da mostrare anche senza taglia scelta: prima disponibile nel colore scelto
    preview() {
      return (
        this.variant() ||
        this.d.variants.find((v) => v.a && (this.ci < 0 || v.o[this.ci] === this.sel[this.ci])) ||
        this.d.variants.find((v) => this.ci < 0 || v.o[this.ci] === this.sel[this.ci]) ||
        this.d.variants[0]
      );
    }

    image() {
      const v = this.preview();
      return (v && v.img) || this.d.img;
    }

    isAvailable(i, val) {
      return this.d.variants.some(
        (v) =>
          v.a &&
          v.o[i] === val &&
          (i === this.ci || this.ci < 0 || v.o[this.ci] === this.sel[this.ci])
      );
    }

    set(i, val, silent) {
      this.sel[i] = val;
      // Cambiando colore la taglia resta solo se esiste ed e disponibile
      if (i === this.ci && this.si >= 0 && this.sel[this.si] && !this.isAvailable(this.si, this.sel[this.si])) {
        this.sel[this.si] = null;
      }
      this.added = false;
      this.setMsg('');
      this.render();
      if (!silent) this.root.onItemChange();
    }

    // Abbina il colore: nome uguale, poi colore base, altrimenti il principale
    matchColor(name) {
      if (this.ci < 0) return;
      const vals = this.values(this.ci);
      const m =
        vals.find((v) => norm(v) === norm(name)) ||
        vals.find((v) => base(v) === base(name)) ||
        this.d.defaultColor ||
        vals[0];
      this.set(this.ci, m, true);
    }

    matchSize(name) {
      if (this.si < 0) return;
      const vals = this.values(this.si);
      if (vals.length === 1 && this.isAvailable(this.si, vals[0])) {
        this.sel[this.si] = vals[0];
      } else {
        const m = name && vals.find((v) => norm(v) === norm(name));
        this.sel[this.si] = m && this.isAvailable(this.si, m) ? m : null;
      }
      this.render();
    }

    selectVariant(id) {
      const v = this.d.variants.find((x) => x.id === id);
      if (!v) return false;
      this.sel = v.o.slice();
      this.added = false;
      this.setMsg('');
      this.render();
      return true;
    }

    setMsg(text, isError) {
      this.msg.textContent = text;
      this.msg.classList.toggle('rcl-msg--error', Boolean(isError && text));
      this.el.classList.toggle('rcl-item--alert', Boolean(isError && text));
    }

    render() {
      const s = this.root.s;
      this.el.querySelectorAll('[data-rcl-option]').forEach((fs) => {
        const i = Number(fs.dataset.rclOption);
        fs.querySelectorAll('[data-rcl-value]').forEach((b) => {
          const val = b.dataset.rclValue;
          b.setAttribute('aria-pressed', String(val === this.sel[i]));
          const ok = this.isAvailable(i, val);
          b.classList.toggle('is-unavailable', !ok);
          if (i !== this.ci) b.disabled = !ok;
        });
      });
      if (this.colorLabel && this.ci >= 0) this.colorLabel.textContent = this.sel[this.ci] || '';

      const pv = this.preview();
      if (this.img && this.image() && this.img.getAttribute('src') !== this.image()) this.img.src = this.image();
      if (pv) {
        const sale = pv.c > pv.p;
        this.price.innerHTML =
          `<span class="rcl-price${sale ? ' rcl-price--sale' : ''}">${money(pv.p)}</span>` +
          (sale ? `<s class="rcl-price__compare">${money(pv.c)}</s>` : '');
      }

      const v = this.variant();
      this.btn.classList.toggle('is-added', this.added);
      if (this.added) {
        this.btn.textContent = s.added;
        this.btn.disabled = false;
      } else if (v && !v.a) {
        this.btn.textContent = s.soldOut;
        this.btn.disabled = true;
      } else {
        this.btn.textContent = s.add;
        this.btn.disabled = false;
      }
    }
  }

  customElements.define(
    'risalti-complete-look',
    class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.s = JSON.parse(this.querySelector('[data-rcl-strings]').textContent);
        this.addUrl = (this.dataset.cartAddUrl || '/cart/add').replace(/\.js$/, '') + '.js';

        // Il cassetto va nel body: dentro il blocco prodotto un transform rompe il position: fixed
        const id = this.dataset.drawerId;
        document.querySelectorAll(`body > drawer-element#${id}`).forEach((d) => d.remove());
        this.drawer = this.querySelector(`#${id}`);
        document.body.appendChild(this.drawer);

        this.items = {};
        this.drawer.querySelectorAll('[data-rcl-item]').forEach((el) => {
          const item = new LookItem(this, el);
          this.items[item.role] = item;
        });
        this.main = this.items.main;
        this.look = this.items.look;
        this.thumbs = {
          main: this.querySelector('[data-rcl-thumb="main"]'),
          look: this.querySelector('[data-rcl-thumb="look"]'),
        };
        this.bothBtn = this.drawer.querySelector('[data-rcl-add-both]');
        this.bothMsg = this.drawer.querySelector('[data-rcl-msg-both]');
        this.bothBtn.addEventListener('click', () => this.add([this.main, this.look]));

        this.syncFromMain();

        if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
          this.unsubscribe = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, (e) => {
            const v = e && e.data && e.data.variant;
            if (v && this.main.selectVariant(v.id)) this.syncFromMain();
          });
        }
        guardCartToggle();
      }

      // Se il blocco viene tolto dalla pagina, porto via anche il cassetto spostato nel body
      disconnectedCallback() {
        setTimeout(() => {
          if (this.isConnected) return;
          if (this.unsubscribe) this.unsubscribe();
          if (this.drawer && this.drawer.parentNode === document.body) this.drawer.remove();
        }, 0);
      }

      // Colore e taglia del capo in pagina -> pezzo abbinato
      syncFromMain() {
        const m = this.main;
        if (m.ci >= 0) this.look.matchColor(m.sel[m.ci]);
        this.look.matchSize(m.si >= 0 ? m.sel[m.si] : null);
        this.look.added = false;
        this.look.render();
        this.main.render();
        this.onItemChange();
      }

      onItemChange() {
        ['main', 'look'].forEach((r) => {
          const t = this.thumbs[r];
          const src = this.items[r].image();
          if (t && src) {
            const w300 = src.replace(/width=\d+/, 'width=300');
            if (t.getAttribute('src') !== w300) {
              t.src = w300;
              t.srcset = `${src.replace(/width=\d+/, 'width=150')} 150w, ${w300} 300w`;
            }
          }
        });
        const both = this.main.added && this.look.added;
        this.bothBtn.textContent = both ? this.s.bothAdded : this.s.addBoth;
        this.bothBtn.classList.toggle('is-added', both);
        const anySoldOut = [this.main, this.look].some((it) => {
          const v = it.variant();
          return v && !v.a;
        });
        this.bothBtn.disabled = anySoldOut;
        this.bothMsg.textContent = '';
        this.bothMsg.classList.remove('rcl-msg--error');
      }

      async add(list) {
        const todo = list.length > 1 ? list.filter((it) => !it.added) : list;
        if (!todo.length) return this.finish();

        const missing = todo.filter((it) => !it.variant());
        if (missing.length) {
          missing.forEach((it) => it.setMsg(this.s.chooseSize, true));
          if (list.length > 1) {
            const names = missing.map((it) => it.el.querySelector('.rcl-item__title').textContent.trim());
            this.bothMsg.textContent = `${this.s.chooseSizeFor} ${names.join(', ')}`;
            this.bothMsg.classList.add('rcl-msg--error');
          }
          const fs = missing[0].el.querySelector('.rcl-opt--size');
          if (fs) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const btns = list.length > 1 ? [this.bothBtn] : todo.map((it) => it.btn);
        btns.forEach((b) => {
          b.disabled = true;
          b.classList.add('is-loading');
          b.textContent = this.s.adding;
        });

        try {
          // Una richiesta per capo: lo script Stape legge un solo articolo per richiesta,
          // quindi con due capi nella stessa chiamata add_to_cart ne tracciava uno solo
          for (const it of todo) {
            const res = await fetch(this.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: it.variant().id, quantity: 1 }] }),
            });
            const json = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(json.description || json.message || this.s.error);

            it.added = true;
            it.setMsg('');
            cartStale = true;
            document
              .querySelectorAll('[data-cart-drawer-toggle]')
              .forEach((t) => t.classList.add('cart__toggle--has-items'));
            document.dispatchEvent(
              new CustomEvent('risalti:look:added', { bubbles: true, detail: { items: json.items || [] } })
            );
          }
        } catch (err) {
          const target = list.length > 1 ? null : todo[0];
          if (target) target.setMsg(err.message || this.s.error, true);
          else {
            this.bothMsg.textContent = err.message || this.s.error;
            this.bothMsg.classList.add('rcl-msg--error');
          }
        } finally {
          btns.forEach((b) => b.classList.remove('is-loading'));
          todo.forEach((it) => it.render());
          this.onItemChange();
        }

        if (this.main.added && this.look.added) setTimeout(() => this.finish(), list.length > 1 ? 400 : 900);
      }

      // Entrambi nel carrello: chiudo il cassetto e apro il carrello aggiornato
      finish() {
        if (this.drawer.isOpen && this.drawer.isOpen()) this.drawer.close();
        openCart();
      }
    }
  );
})();
